module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "B"
    }
  }, [_vm._v("qqqqqq")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03936c7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/CloudWeApp.vue
// module id = 1407
// module chunks = 18